import { __decorate, __metadata } from "tslib";
import { translate } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import '../../../../../shared-elements/balance-view';
import { tokenBalanceAndMaxButtonStyle } from './token-balance-and-max-button.style';
let TokenBalanceAndMaxButtonElement = class TokenBalanceAndMaxButtonElement extends LitElement {
    static { this.tagName = 'inch-token-balance-and-max-button'; }
    static { this.styles = tokenBalanceAndMaxButtonStyle; }
    render() {
        if (!this.tokenId || !this.walletAddress || !this.symbol) {
            return html ``;
        }
        return html `
      <span>${translate('widgets.swap-form.input.balance.balance')}:</span>
      <inch-token-balance
        .tokenId="${this.tokenId}"
        .symbol="${this.symbol}"
        .walletAddress="${this.walletAddress}"
      ></inch-token-balance>
      ${when(this.tokenType === 'source', () => html `<inch-button size="xs" type="secondary">MAX</inch-button>`)}
    `;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceAndMaxButtonElement.prototype, "tokenType", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceAndMaxButtonElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceAndMaxButtonElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceAndMaxButtonElement.prototype, "symbol", void 0);
TokenBalanceAndMaxButtonElement = __decorate([
    customElement(TokenBalanceAndMaxButtonElement.tagName)
], TokenBalanceAndMaxButtonElement);
export { TokenBalanceAndMaxButtonElement };
//# sourceMappingURL=token-balance-and-max-button.element.js.map